import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import guardiansService from "../services/guardiansService";
import styles from "../assets/propertyApplicationDeclineDocumentation.module.css";
import Loader from "../components/Loader";

const PropertyApplicationDeclineDocumentation = () => {
  const { guardianId } = useParams();
  const navigate = useNavigate();
  const [guardian, setGuardian] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [reason, setReason] = useState("");

  const loadGuardian = useCallback(async () => {
    try {
      setLoading(true);
      const data = await guardiansService.getGuardianById(guardianId);
      setGuardian(data);
    } catch (err) {
      console.error("Error loading guardian:", err);
      setError("Failed to load guardian details");
      toast.error("Failed to load guardian details");
    } finally {
      setLoading(false);
    }
  }, [guardianId]);

  useEffect(() => {
    loadGuardian();
  }, [loadGuardian]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      toast.error("Please provide a reason for declining the documentation");
      return;
    }

    setSubmitting(true);

    try {
      await guardiansService.declineDocumentationConfirm(guardianId, reason);
      toast.success('You declined documentation!');
      navigate('/guardians');
    } catch (error) {
      console.error('Error declining documentation:', error);
      toast.error('Failed to decline documentation');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/guardians');
  };

  if (loading) return <Loader />;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container">
      {/* Breadcrumbs */}
      <div className={styles.breadcrumbs}>
        <span
          onClick={() => navigate('/dashboard')}
          className={styles.breadcrumbLink}
        >
          Dashboard
        </span>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <div className={`${styles.panelTitle} border-down`}>
              <h3>Decline documentation reason</h3>
            </div>

            <div className={styles.panelGroup}>
              <div className={styles.approvedDescription}>
                Fill in and submit your reason of decline Guardians documents. This will be sent via email.
              </div>

              {/* Guardian Information Display - Laravel equivalent */}
              {guardian && (
                <div className={styles.guardianInfo}>
                  <h4>Guardian Information:</h4>
                  <p><strong>Name:</strong> {guardian.fullName || `${guardian.user?.first_name} ${guardian.user?.last_name}`}</p>
                  <p><strong>Email:</strong> {guardian.user?.email}</p>
                  <p><strong>Status:</strong> {guardian.status?.name || 'Unknown'}</p>
                </div>
              )}

              <fieldset className="form-horizontal">
                <div className="row">
                  <div className="col-sm-8">
                    <textarea
                      name="reason"
                      className={`form-control ${styles.reasonTextarea}`}
                      rows="6"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder="Enter your reason for declining the documentation..."
                      required
                    />
                  </div>
                </div>

                <div className={`row ${styles.buttonRow}`}>
                  <div className="col-sm-8">
                    <button
                      type="button"
                      onClick={handleCancel}
                      className={`btn btn-default ${styles.cancelBtn}`}
                    >
                      <i className="glyphicon glyphicon-chevron-left"></i>
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className={`${styles.submitBtn} pull-right`}
                      disabled={submitting || !reason.trim()}
                    >
                      {submitting ? 'Sending...' : 'Decline and send email'}
                      <i className="glyphicon glyphicon-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PropertyApplicationDeclineDocumentation;